document.addEventListener("DOMContentLoaded", function () {
  /**
   * PDP - Product Tabs aria-label
   */
  const pdpTabsSection = document.querySelector(".tend-product-tabs");

  if (pdpTabsSection) {
    pdpTabsSection.setAttribute("aria-label", "Product Tabs");
  }

  /**
   * PDP - Product Tabs keydown event
   */
  setTimeout(() => {
    const moreInfoTabLinks = document.querySelectorAll(".more-info-tabs__nav-link");

    console.log(moreInfoTabLinks);

    moreInfoTabLinks.forEach((tabLink) => {
      console.log(tabLink);

      tabLink.addEventListener("keydown", (e) => {
        if (e.key === "Enter" || e.key === " ") {
          e.preventDefault();
          tabLink.click();
        }
      });
    });
  }, 5000);

  /**
   * PDP - Product Recommendations aria-label
   */
  const pdpRecSection = document.querySelector(".tend-product-recommendations");

  if (pdpRecSection) {
    pdpRecSection.setAttribute("aria-label", "Product Recommendations");
  }

  /**
   * Seasonal Subscription PDP related functions
   */
  function getSubscriptionPlanID(firstBox = "", subscriptionType = "") {
    var sellingPlanId = "";

    if (subscriptionType === "Quarterly Subscription") {
      if (firstBox.includes("Current Season")) {
        sellingPlanId = "693843067206";
      } else if (firstBox.includes("Next Season")) {
        sellingPlanId = "693843099974";
      }
    } else if (subscriptionType === "Yearly Subscription") {
      if (firstBox === "Current Season (Spring)" || firstBox === "Next Season (Spring)") {
        sellingPlanId = "693843132742";
      } else if (firstBox === "Current Season (Summer)" || firstBox === "Next Season (Summer)") {
        sellingPlanId = "693845918022";
      } else if (firstBox === "Current Season (Autumn)" || firstBox === "Next Season (Autumn)") {
        sellingPlanId = "693845983558";
      } else if (firstBox === "Current Season (Winter)" || firstBox === "Next Season (Winter)") {
        sellingPlanId = "693846049094";
      }
    }

    return sellingPlanId;
  }

  function updateSubscriptionSettings() {
    const $sellingPlanSelect = $(".paywhirl-plan-selector-plan select");

    if (!$sellingPlanSelect.length) {
      return;
    }

    const firstBox = $('input[name="properties[First Box]"]:checked').val() || "";
    const subscriptionType = $('.variants-wrapper[data-variant-label="subscription-type"] .single-option-selector input:checked').val() || "";

    let isQuarterlySubscription = subscriptionType === "Quarterly Subscription" ? true : false;
    let isYearlySubscription = subscriptionType === "Yearly Subscription" ? true : false;

    let subscriptionSlug = "yearly-subscription";
    if (isQuarterlySubscription == true) {
      subscriptionSlug = "quarterly-subscription";
    }

    /******************************************************************
     * SET SELLING PLAN ID
     ******************************************************************/
    var sellingPlanId = getSubscriptionPlanID(firstBox, subscriptionType);

    if (sellingPlanId) {
      const payWhirlSelect = $sellingPlanSelect[0];

      if (payWhirlSelect && payWhirlSelect.value !== sellingPlanId) {
        payWhirlSelect.value = sellingPlanId;

        payWhirlSelect.dispatchEvent(
          new InputEvent("input", {
            bubbles: true,
          }),
        );

        payWhirlSelect.dispatchEvent(
          new Event("change", {
            bubbles: true,
          }),
        );
      }
    }

    /******************************************************************
     * UPDATE PRODUCT PRICE DISPLAY AND DISCLAIMER TEXT
     ******************************************************************/
    setTimeout(() => {
      let variantPrices = {
        56607265685830: "26.25",
        56710746046790: "105.00",
        56607265784134: "42.50",
        56710746079558: "170.00",
        56607265882438: "57.50",
        56710746112326: "230.00",
        56607265980742: "69.95",
        56710746145094: "279.80",
      };
      let selectedVariant = $('select[name="id"]').val();
      let variantPrice = Number(variantPrices[selectedVariant]);
      let yearlySubDiscount = 0.1;

      if (!isNaN(variantPrice)) {
        let yearlySubscriptionPrice;
        let updatedPrice;
        let subscriptionMessage;

        if (isQuarterlySubscription == true) {
          yearlySubscriptionPrice = variantPrice * 4;
          yearlySubscriptionPrice = yearlySubscriptionPrice.toFixed(2);
          updatedPrice = variantPrice;
          subscriptionMessage = " per year (plus shipping), charged in four instalments. Receive 4 seasonal lawn boxes.";
        } else {
          let discountedPrice = variantPrice * yearlySubDiscount;
          yearlySubscriptionPrice = (variantPrice - discountedPrice).toFixed(2);
          updatedPrice = yearlySubscriptionPrice;
          subscriptionMessage = " charged once per year (plus shipping). Receive 4 seasonal lawn boxes.";
        }

        $(".js-product-price.product-single__price").attr("content", updatedPrice);

        $(".js-product-price.product-single__price").text("£" + updatedPrice);

        $('.subscription-card[data-subscription-type="' + subscriptionSlug + '"] .subscription-card__price .price').text("£" + updatedPrice);

        $(".subscription_price_disclaimer").html('<span class="price">£' + yearlySubscriptionPrice + "</span>" + subscriptionMessage);

        $(".btn.btn--add-to-cart .price_text").html("£" + updatedPrice);
      }
    }, 500);

    /******************************************************************
     * UPDATE SUBSCRIPTION FREQUENCY
     ******************************************************************/
    let subscriptionFrequency = "";

    if (isQuarterlySubscription == true) {
      subscriptionFrequency = "season";
    } else {
      subscriptionFrequency = "year";
    }

    $(".btn--add-to-cart .subscription_frequency").text(subscriptionFrequency);

    $(".js-product-price[data-subscription-frequency]").attr("data-subscription-frequency", subscriptionFrequency);

    /******************************************************************
     * UPDATE RENEWAL DATE AND THE ASSOCIATED PRODUCTS
     ******************************************************************/
    if (firstBox != "") {
      let renewalDate = $('input[name="properties[First Box]"]:checked').next("label").attr("data-renewal-date");

      if (renewalDate) {
        $('.subscription-card[data-subscription-type="' + subscriptionSlug + '"] .season-options-info .renewal_date').html(renewalDate);
      }

      if (isQuarterlySubscription == true) {
        let currentSeasonProductChange = "";
        let nextSeasonProductChange = "";
        if (firstBox.includes("Current Season")) {
          currentSeasonProductChange = $('.subscription-card[data-subscription-type="' + subscriptionSlug + '"] .season-options-info .text').attr(
            "data-firstbox-current-product",
          );
          nextSeasonProductChange = $('.subscription-card[data-subscription-type="' + subscriptionSlug + '"] .season-options-info .text').attr(
            "data-firstbox-next-product",
          );
        } else {
          currentSeasonProductChange = $('.subscription-card[data-subscription-type="' + subscriptionSlug + '"] .season-options-info .text').attr(
            "data-firstbox-current-product-change",
          );
          nextSeasonProductChange = $('.subscription-card[data-subscription-type="' + subscriptionSlug + '"] .season-options-info .text').attr(
            "data-firstbox-next-product-change",
          );
        }

        $(".season-options-info .current-season-product").html(currentSeasonProductChange);
        $(".season-options-info .next-season-product").html(nextSeasonProductChange);
      }
    }
  }

  /**
   * Wait for PayWhirl select to be added to DOM
   */
  const payWhirlSubscriptionObserver = new MutationObserver(function () {
    const $sellingPlanSelect = $(".paywhirl-plan-selector-plan select");

    if ($sellingPlanSelect.length) {
      updateSubscriptionSettings();

      payWhirlSubscriptionObserver.disconnect();
    }
  });

  payWhirlSubscriptionObserver.observe(document.body, {
    childList: true,
    subtree: true,
  });

  $(document).on("change", 'input[name="properties[First Box]"]', updateSubscriptionSettings);

  /**
   * Tooltips for seasonal subscription accordion
   */
  class SeasonTooltip {
    constructor(trigger) {
      this.trigger = trigger;

      const tooltipId = trigger.getAttribute("aria-describedby");

      if (!tooltipId) return;

      this.tooltip = document.querySelector("#" + tooltipId);

      if (!this.tooltip) return;

      this.show = this.show.bind(this);
      this.hide = this.hide.bind(this);
      this.handleEscape = this.handleEscape.bind(this);

      trigger.addEventListener("mouseenter", this.show);
      trigger.addEventListener("focus", this.show);

      trigger.addEventListener("mouseleave", this.hide);
      trigger.addEventListener("blur", this.hide);

      trigger.addEventListener("pointerdown", (e) => {
        e.preventDefault();
        const isVisible = this.tooltip.classList.contains("is-visible");

        document.querySelectorAll(".season-tooltip.is-visible").forEach((t) => {
          t.classList.remove("is-visible");
          t.setAttribute("aria-hidden", "true");
        });

        if (!isVisible) {
          this.show();
        }
      });

      this.tooltip.addEventListener("mouseenter", this.show);
      this.tooltip.addEventListener("mouseleave", this.hide);

      document.addEventListener("keydown", this.handleEscape);
    }

    show() {
      this.tooltip.classList.add("is-visible");

      const parent = this.tooltip.offsetParent || this.tooltip.closest(".seasonal-subscription-cart-item-data__card");

      const triggerRect = this.trigger.getBoundingClientRect();
      const parentRect = parent.getBoundingClientRect();

      const left = triggerRect.left - parentRect.left + triggerRect.width / 2;

      const top = triggerRect.top - parentRect.top - this.tooltip.offsetHeight - 16;

      this.tooltip.style.position = "absolute";

      this.tooltip.style.left = `${left}px`;

      this.tooltip.style.top = `${top}px`;

      this.tooltip.style.transform = "translateX(-50%)";
    }

    hide() {
      this.tooltip.classList.remove("is-visible");
      this.tooltip.setAttribute("aria-hidden", "true");
    }

    handleEscape(event) {
      if (event.key === "Escape") {
        this.hide();
        this.trigger.blur();
      }
    }
  }

  function initSeasonTooltips() {
    document.querySelectorAll(".season-tooltip-trigger").forEach((trigger) => {
      if (trigger.dataset.tooltipInitialized) return;

      trigger.dataset.tooltipInitialized = "true";
      new SeasonTooltip(trigger);
    });
  }

  const seasonTooltipsObserver = new MutationObserver(() => {
    initSeasonTooltips();
  });

  seasonTooltipsObserver.observe(document.body, {
    childList: true,
    subtree: true,
  });
});
